import axios from "axios";

export const PERSONNEL_URL = "/Personnel";
export const STUDENT_PRE_INTERVIEW_URL = "/StudentPreInterview";

/** Mevcut Okulun Belli Bir Ön Kayıt ve Görüşme Listesini Elde Eder */
export function getStudentPreInterviews(queryParams) {
  return axios.post(`${STUDENT_PRE_INTERVIEW_URL}/GetStudentPreInterviews`, queryParams);
}

/** Mevcut Okulun Belli Bir Ön Kayıt ve Görüşme Listesini Sayfalama Olmadan Elde Eder */
export function getAllStudentPreInterviews(queryParams) {
  return axios.post(`${STUDENT_PRE_INTERVIEW_URL}/GetAllStudentPreInterviews`, queryParams);
}

/** Mevcut Okulun Belli Bir Görüşme Listesini Elde Eder */
export function getInterviews(queryParams) {
  return axios.post(`${STUDENT_PRE_INTERVIEW_URL}/GetInterviews`, queryParams);
}

/** Mevcut Okulun Belli Bir Dönemde Sözleşmesi Olan Personel Listesini Elde Eder */
export function getPersonnels(term) {
  return axios.get(`${PERSONNEL_URL}/GetPersonnels/${term}`);
}

/** Yeni Bir Ön Kayıt ve Görüşme Elde Eder */
export function getNewStudentPreInterview() {
  return axios.get(STUDENT_PRE_INTERVIEW_URL);
}

/** Belli Bir Ön Kaydı Elde Eder */
export function getStudentPreInterview(id) {
  return axios.get(`${STUDENT_PRE_INTERVIEW_URL}/${id}`);
}

/** Belli Bir Ön Kaydı Elde Eder */
export function getInterview(id) {
  return axios.get(`${STUDENT_PRE_INTERVIEW_URL}/GetInterview/${id}`);
}

/** Belli Bir Ön Kayıt ve Görüşmeyi Kaydeder */
export function saveStudentPreInterview(preInterview) {
  return axios.post(STUDENT_PRE_INTERVIEW_URL, preInterview);
}

/** Belli Bir Görüşmeyi Kaydeder */
export function saveInterview(interview) {
  return axios.post(`${STUDENT_PRE_INTERVIEW_URL}/SaveInterview`, interview);
}

/** Belli Bir Ön Kayıt ve Görüşme Listesini Siler */
export function deleteStudentPreInterviews(ids) {
  return axios.post(`${STUDENT_PRE_INTERVIEW_URL}/Delete`, { ids });
}